import React from "react";
import { coaches } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Coaches() {
  const { ref, inView } = useReveal();
  return (
    <section id="coaches" className="relative py-24 bg-background">
      <div className="max-w-7xl mx-auto px-5">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""}`}>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-gold" />
            <span className="section-label text-gold text-xs">Team Managers & Coaches</span>
          </div>
          <h2 className="display-font uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            The people behind <span className="text-gold">the crest.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {coaches.map((c) => (
            <div
              key={c.name}
              className="group relative rounded-xl overflow-hidden border border-white/10 bg-card p-8 text-center hover:border-gold/60 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-gold/5 group-hover:bg-gold/10 transition-colors" />
              <div className="relative mx-auto w-40 h-40">
                <div className="absolute inset-0 rounded-full ring-2 ring-gold/40 group-hover:ring-gold transition-all" />
                <img
                  src={c.img}
                  alt={c.name}
                  className="w-40 h-40 rounded-full object-cover bg-secondary group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="relative cond-font uppercase tracking-wide text-xl text-white mt-6">{c.name}</h3>
              <div className="relative mx-auto mt-2 w-10 h-[2px] bg-gold" />
              <p className="relative cond-font uppercase tracking-widest text-xs text-gold mt-3">{c.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
